export default __webpack_public_path__ + "static/media/img-5.e6d7fa25.png";